/* Wreckfest overlay — leest events die door de Pterodactyl-log-parser
   worden gepusht (fase 2).
   Verwachte events:
   - "race_start":  { track, laps }
   - "race_status": { current_lap, total_laps }
   - "finish":      { position, name, time, points }
   - "race_end":    { podium: [{ position, name, time }] } */

export default function WreckfestOverlayVariant({ byType, context }) {
  const raceStart  = byType?.race_start?.data
  const raceStatus = byType?.race_status?.data
  const raceEnd    = byType?.race_end?.data
  const hasCtx = !!context?.team_a || !!context?.team_b || !!context?.tournament

  if (raceEnd?.podium) return (
    <>
      {hasCtx && <ContextHeader context={context} />}
      <Podium podium={raceEnd.podium} track={raceStart?.track} />
    </>
  )

  if (!raceStart) {
    return (
      <>
        {hasCtx && <ContextHeader context={context} />}
        <div style={waiting}><div style={label}>Wreckfest · wacht op race…</div></div>
      </>
    )
  }

  return (
    <>
      {hasCtx && <ContextHeader context={context} />}
      <div style={topBar}>
        <div style={pill}>{raceStart.track || 'Track ?'}</div>
        <div style={{ fontFamily: 'Rajdhani, system-ui, sans-serif', fontSize: 32, fontWeight: 700 }}>
          Ronde {raceStatus?.current_lap ?? 1}/{raceStatus?.total_laps ?? raceStart.laps ?? '?'}
        </div>
      </div>
    </>
  )
}

function ContextHeader({ context }) {
  const t = context.tournament
  const m = context.match
  const a = context.team_a?.name
  const b = context.team_b?.name
  return (
    <div style={ctxHeader}>
      {a && b && (
        <span style={ctxTitle}>{a} <span style={{ color: '#94A3B8' }}>vs</span> {b}</span>
      )}
      <span style={ctxMeta}>
        {t?.name}{m?.round ? ` · R${m.round}·M${m.match_number}` : ''}
      </span>
    </div>
  )
}

function Podium({ podium, track }) {
  const top = (podium || []).slice(0, 3)
  return (
    <div style={{
      position: 'fixed', inset: 0, display: 'grid', placeItems: 'center',
      background: 'linear-gradient(rgba(0,0,0,.4), rgba(0,0,0,.7))',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontFamily: 'monospace', fontSize: 12, letterSpacing: '.3em', color: '#E4C265', marginBottom: 8 }}>
          Finish · {track || ''}
        </div>
        <div style={{ display: 'flex', gap: 24, alignItems: 'flex-end' }}>
          {top.map((r, i) => (
            <div key={r.name || i} style={{
              padding: 16, minWidth: 180, textAlign: 'center',
              background: 'rgba(0,0,0,.7)', border: `2px solid ${podiumColor(i + 1)}`,
              borderRadius: 6, transform: i === 0 ? 'translateY(-16px)' : '',
            }}>
              <div style={{ fontFamily: 'monospace', fontSize: 11, color: podiumColor(i + 1), letterSpacing: '.2em' }}>
                #{i + 1}
              </div>
              <div style={{ fontSize: 22, fontWeight: 700, margin: '4px 0' }}>{r.name}</div>
              {r.time && <div style={{ fontFamily: 'monospace', fontSize: 12, color: '#ccc' }}>{r.time}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
function podiumColor(p) { return p === 1 ? '#E4C265' : p === 2 ? '#C0C1C7' : '#FFB57A' }

const label = { fontFamily: 'monospace', fontSize: 12, letterSpacing: '.2em',
                textTransform: 'uppercase', color: '#B4FF39', opacity: .7 }
const waiting = { position: 'fixed', top: '50%', left: '50%',
                  transform: 'translate(-50%,-50%)',
                  padding: '16px 24px', background: 'rgba(0,0,0,.6)', borderRadius: 8 }
const topBar = {
  position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)',
  display: 'flex', alignItems: 'center', gap: 24,
  padding: '12px 28px', background: 'rgba(10,10,10,.75)',
  border: '1px solid rgba(255,255,255,.08)', borderRadius: 8,
}
const pill = { fontFamily: 'monospace', fontSize: 13, letterSpacing: '.2em',
               textTransform: 'uppercase', padding: '4px 10px',
               background: 'rgba(255,255,255,.06)', borderRadius: 4, color: '#B4FF39' }
const ctxHeader = {
  position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)',
  display: 'flex', alignItems: 'center', gap: 14,
  padding: '6px 16px', background: 'rgba(0,0,0,.72)',
  border: '1px solid rgba(180,255,57,.28)', borderRadius: 6,
}
const ctxTitle = {
  fontFamily: 'system-ui, sans-serif', fontSize: 14, fontWeight: 700, color: '#fff',
}
const ctxMeta = {
  fontFamily: 'monospace', fontSize: 10, letterSpacing: '.18em', textTransform: 'uppercase',
  color: '#B4FF39',
}
